package horcrux.frontend.common.extensions

import horcrux.common.api.dtos.ChatMessage
import horcrux.common.api.dtos.TheGrokAppChatMessage
import horcrux.common.api.dtos.UserChatMessage
import horcrux.common.types.TruncatedString
import horcrux.frontend.common.views.chat.ChatMessageData
import horcrux.frontend.common.views.chat.TheGrokApp
import horcrux.frontend.common.views.chat.User

operator fun ChatMessage.Companion.invoke(chatMessageData: ChatMessageData): ChatMessage =
    when (val messageSenderData = chatMessageData.messageSenderData) {
        is TheGrokApp -> TheGrokAppChatMessage(
            message = TruncatedString(chatMessageData.content),
            contextDocumentChunkAndMetadataList = messageSenderData.contextDocumentChunkAndMetadataList
        )

        is User -> UserChatMessage(
            message = TruncatedString(chatMessageData.content)
        )
    }
